
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/perfil/configuracion/cambiar-clave",
      function () {
        return require("private-next-pages/perfil/configuracion/cambiar-clave/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/perfil/configuracion/cambiar-clave"])
      });
    }
  